import { render, staticRenderFns } from "./RdrQuickViewCapture.vue?vue&type=template&id=2ca6c798&scoped=true"
import script from "./RdrQuickViewCapture.vue?vue&type=script&lang=js"
export * from "./RdrQuickViewCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6c798",
  null
  
)

export default component.exports